import PropTypes from 'prop-types';
import React from 'react';
import { findHtmlInnerText } from '@helpers/findHtmlInnerText';
import OURichTextResolver from '@resolvers/OURichTextResolver';

export default function GenericMessage(messageCode, moduleCode, presCode, replacementTokens, genericMessages, mode) {
  //if (!PageContext) return null;
  //if (!PageContext.genericMessages) return null;
  if (!messageCode) return null;

  let message = null;

  const messageModulePres = [messageCode, moduleCode, presCode].join('-');
  const messageModule = [messageCode, moduleCode].join('-');

  // See if we can find messagecode-module-pres first.
  message = genericMessages?.find((x) => x.node.elements.code.value === messageModulePres)?.node?.elements?.message;

  // If no message found then try messagecode-module.
  if (!message) {
    message = genericMessages?.find((x) => x.node.elements.code.value === messageModule)?.node?.elements?.message;
  }

  // If no message found then try messagecode.
  if (!message) {
    message = genericMessages?.find((x) => x.node.elements.code.value === messageCode)?.node?.elements?.message;
  }

  if (!message) return null;

  // Take a copy of the current message object.
  let formatted_message = { ...message };

  if (replacementTokens) {
    replacementTokens.forEach((replacementToken) => {
      const regex = new RegExp(`\\[${replacementToken.key}]`, 'g');

      formatted_message.value = formatted_message.value.replace(regex, replacementToken.value);
    });
  }

  if (mode === 'FINANCIALSUPPORT') {
    return (
      <tr>
        <td colSpan="100%">
          <i>{findHtmlInnerText(formatted_message.value)}</i>
        </td>
      </tr>
    );
  } else if (mode === 'INNERHTML') {
    return findHtmlInnerText(formatted_message.value);
  } else {
    return <OURichTextResolver rtObj={formatted_message} theme="dark" paragraphNoMargins={true} />;
  }
}

GenericMessage.propTypes = {
  messageCode: PropTypes.string,
  moduleCode: PropTypes.string,
  presCode: PropTypes.string,
  replacementTokens: PropTypes.array,
  genericMessages: PropTypes.array,
  mode: PropTypes.string,
};
